"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _captcha = require("../../consts/captcha");
var _login = require("../../servers/login");
var _classnames = _interopRequireDefault(require("classnames"));
var _Portal = _interopRequireDefault(require("../Portal"));
require("./style.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
// 占位验证码
var CAPTCHA_LIST = new Array(9).fill(0);
var DOMAIN_URL = window.location.host;
var Index = function Index(props) {
  var bId = props.bId,
    captchaItem = props.captchaItem,
    refreshCaptcha = props.refreshCaptcha,
    _props$mask = props.mask,
    mask = _props$mask === void 0 ? true : _props$mask,
    _props$closable = props.closable,
    closable = _props$closable === void 0 ? true : _props$closable,
    _props$confirmable = props.confirmable,
    confirmable = _props$confirmable === void 0 ? true : _props$confirmable,
    balanceCode = props.balanceCode,
    onChange = props.onChange,
    handleInitFunc = props.handleInitFunc,
    publicIp = props.publicIp;
  // 选择验证码
  var _useState = (0, _react.useState)([-1, -1, -1, -1]),
    _useState2 = _slicedToArray(_useState, 2),
    selectCaptcha = _useState2[0],
    setSelectCaptcha = _useState2[1];
  // 二维码图片
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    captchaImg = _useState4[0],
    setCaptchaImg = _useState4[1];
  //cookies
  var _useState5 = (0, _react.useState)(''),
    _useState6 = _slicedToArray(_useState5, 2),
    cookies = _useState6[0],
    setCookies = _useState6[1];
  // 记录当前点击
  var _useState7 = (0, _react.useState)(0),
    _useState8 = _slicedToArray(_useState7, 2),
    idx = _useState8[0],
    setIdx = _useState8[1];
  (0, _react.useEffect)(function () {
    getCaptchaImgFunc();
  }, [captchaItem]);
  var getCaptchaImgFunc = function getCaptchaImgFunc() {
    if (Object.keys(captchaItem).length) {
      var gyUrl = captchaItem.gy_url.split(':')[1];
      var url = "".concat(gyUrl, "?bid=").concat(bId, "&domain=").concat(DOMAIN_URL);
      (0, _login.getCaptchaImg)({
        url: url
      }).then(function (res) {
        if (res.success) {
          setCaptchaImg(res.data);
          setCookies(res.message);
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  };
  /**
   * 刷新验证码
   */
  var handleCaptchaRefresh = function handleCaptchaRefresh() {
    handleInitFunc && handleInitFunc();
    getCaptchaImgFunc();
    setIdx(0);
    setSelectCaptcha([-1, -1, -1, -1]);
  };
  /**
   * 选择验证码
   * @param index 点击的索引
   */
  var handleCaptchaSelect = function handleCaptchaSelect(index) {
    if (idx === 4) {
      return;
    }
    var list = selectCaptcha;
    list[idx] = index;
    setIdx(idx + 1);
    setSelectCaptcha(list);
  };
  /**
   * 删除验证码
   */
  var handleCaptchaDelete = function handleCaptchaDelete() {
    if (idx === 0) {
      return;
    }
    selectCaptcha[idx - 1] = -1;
    setIdx(idx - 1);
    setSelectCaptcha(selectCaptcha);
  };
  /**
   * 提交
   */
  var handleSubmit = function handleSubmit() {
    if (idx < 4) {
      return;
    }
    var captcha = selectCaptcha.join('');
    props.onSubmit(_objectSpread({
      captcha: captcha,
      cookies: cookies,
      balanceCode: balanceCode,
      type: _captcha.CAPTCHA_TYPE.gywd
    }, publicIp && {
      publicIp: publicIp
    }));
  };
  /**
   * 关闭
   */
  var handleClose = function handleClose() {
    props.onClose();
  };
  (0, _react.useEffect)(function () {
    if (refreshCaptcha && refreshCaptcha !== 0) {
      handleCaptchaRefresh();
    }
  }, [refreshCaptcha]);
  (0, _react.useEffect)(function () {
    onChange && onChange({
      completed: idx === 4
    });
    if (idx === 4 && !confirmable) {
      handleSubmit();
    }
  }, [idx]);
  return /*#__PURE__*/_react.default.createElement(_Portal.default, {
    container: props.getContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('gy_captcha_modal_new', props.wrapClassName)
  }, mask && /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_captcha_mask"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('gy_captcha_content', {
      modal_container_content: props.getContainer
    })
  }, closable && /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_captcha_header"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "gy_captcha_text"
  }, "\u8F93\u5165\u9A8C\u8BC1\u7801"), /*#__PURE__*/_react.default.createElement("span", {
    className: "gy_captcha_close",
    onClick: handleClose
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_captcha_title"
  }, "\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801\u5B8C\u6210\u767B\u5F55"), /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_captcha_body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_captcha_info"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_captcha_header_in"
  }, /*#__PURE__*/_react.default.createElement("span", null, "\u9A8C\u8BC1\u7801\uFF1A"), /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_captcha_input"
  }, selectCaptcha.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "gy_captcha_input_item",
      key: index
    }, /*#__PURE__*/_react.default.createElement("em", {
      className: (0, _classnames.default)('gy_captcha_item', "gy_captcha_item_".concat(item)),
      id: "gy_captcha_item_".concat(item),
      style: {
        backgroundImage: "url('data:image/png;base64,".concat(captchaImg, "')")
      }
    }));
  }), /*#__PURE__*/_react.default.createElement("em", {
    className: "gy_captcha_item_del",
    onClick: handleCaptchaDelete
  })), /*#__PURE__*/_react.default.createElement("i", {
    className: (0, _classnames.default)('gy_captcha_status', {
      success: idx === 4,
      error: 0 < idx && idx < 4
    })
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_captcha_img_wrap"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "gy_captcha_img",
    onClick: handleCaptchaRefresh,
    style: {
      backgroundImage: "url('data:image/png;base64,".concat(captchaImg, "')")
    }
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "gy_captcha_refresh",
    onClick: handleCaptchaRefresh
  }, "\u770B\u4E0D\u6E05\uFF1F")), /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_captcha_footer"
  }, /*#__PURE__*/_react.default.createElement("p", null, "\u70B9\u51FB\u6846\u5185\u6587\u5B57\u8F93\u5165\u4E0A\u56FE\u4E2D", /*#__PURE__*/_react.default.createElement("b", null, "\u6C49\u5B57"), "\u76F8\u5E94\u6587\u5B57"), /*#__PURE__*/_react.default.createElement("ul", null, CAPTCHA_LIST.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: index,
      className: (0, _classnames.default)('gy_captcha_item', "gy_captcha_item_".concat(index)),
      id: "gy_captcha_item_".concat(index),
      style: {
        backgroundImage: "url('data:image/png;base64,".concat(captchaImg, "')")
      },
      onClick: function onClick() {
        return handleCaptchaSelect(index);
      }
    });
  })), confirmable && /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_captcha_footer_btn",
    id: "btn_login_captcha_submit",
    onClick: handleSubmit
  }, "\u786E\u5B9A")))))));
};
var _default = Index;
exports.default = _default;